document.addEventListener("DOMContentLoaded", function () {
  if (window.AOS) {
    AOS.init({ duration: 800, once: true, offset: 80 });
  }

  // Product gallery (if present)
  const mainImg = document.getElementById("bpMainImage");
  if (mainImg) {
    document.querySelectorAll(".bp-thumb").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        document.querySelectorAll(".bp-thumb").forEach(t => t.classList.remove("active"));
        thumb.classList.add("active");
        mainImg.src = thumb.dataset.full || thumb.src;
      });
    });
  }

  // Quantity controls (product page)
  document.querySelectorAll("[data-bp-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    const minus = wrap.querySelector("[data-bp-minus]");
    const plus = wrap.querySelector("[data-bp-plus]");

    if (!input || !minus || !plus) return;

    plus.addEventListener("click", () => {
      input.value = String(parseInt(input.value || "1", 10) + 1);
      input.dispatchEvent(new Event("change"));
    });

    minus.addEventListener("click", () => {
      const v = parseInt(input.value || "1", 10);
      if (v > 1) input.value = String(v - 1);
      input.dispatchEvent(new Event("change"));
    });
  });
});
